/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    FC,
    $Container,
    ExtendContainerProps,
    getProp,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {$UIText, UITextStyles} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';

export type ListProps = ExtendContainerProps<{
    list: string[];
    margin: number;
    textStyle: UITextStyles;
    maxWidth: number;
}>;

export const $List: FC<ListProps> = (props) => {
    const items = Store.computed(() => {
        const margin = getProp(props.margin);
        const list = getProp(props.list);

        return list.map((item, index) => {
            return <$UIText maxWidth={props.maxWidth} text={item} y={index * margin} stylePreset={props.textStyle}/>;
        });
    });

    return <$Container name='List' {...props}>
        {items}
    </$Container>;
};